import { ServiceCallAction } from "../../store/middleware/serviceCallMiddleware";
import { DashboardCodec, ResponseDashboard } from "../types/DashboardCodec";

export const getDashboardStatistics = (): ServiceCallAction<ResponseDashboard> => ({
	method: "GET",
	endpoint: `recipe/statistics`,
	serviceKey: "getStatistics",
	responseDecoder: DashboardCodec,
	type: "SERVICE_CALL"
});